//Margin conventions
		var margin = {top: 0, right: 10, bottom: 30, left: 35};
		var widther = d3.select(".gia-chart").node().clientWidth;
		var width = widther - margin.left - margin.right,
		    height = 350 - margin.top - margin.bottom;

		//Parses date for correct time format
		var parseDate = d3.timeParse("%b-%y"); 

		//Appends the svg to the chart-container div
		var svg = d3.select(".gia-chart").append("svg")
			.attr("width", width + margin.left + margin.right)
			.attr("height", height + margin.top + margin.bottom)
			.append("g")
			.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

		//Creates the xScale 
			var xScale = d3.scaleBand()
				.rangeRound([0, width])
				.paddingInner(0.25);

			//Creates the yScale
			var yScale = d3.scaleLinear()
				.range([height, 0]);

			//Defines the y axis styles
			var yAxis = d3.axisLeft()
				.scale(yScale)
				.tickSize(-width)
				.tickPadding(8);

			//Adjusts yAxis labels
			function adjustYAxis(selection) {
				selection.selectAll('.y.axis text')
					.attr('transform', 'translate('+ 15 + ',' + -10 + ')' )
			}	

		//Loads the data
		d3.csv("data/jobchange.csv", ready);

		function ready(err, data) {
			if (err) throw "error loading data";

			//FORMAT data
			data.forEach(function(d) {
				d.jobs = +d.jobs;
		    	d.date = parseDate(d.date);
			});

		  	//Sets min and max on xScale
		  	var xMin = d3.min(data, function(d) { return d.date;});
		  	var xMax = d3.max(data, function(d) { return d.date;});
		  	var yMin = d3.min(data, function(d) { return d.jobs;});
		  	var yMax = d3.max(data, function(d) { return d.jobs;});


		  	//Sets scale domains
  			xScale.domain(data.map(function(d) { return d.date; }));
  			yScale.domain([0, yMax])

		  	//Defines the x axis styles
		  	var xAxis = d3.axisBottom()
		    	.scale(xScale)
		    	.tickPadding(8)
		    	.tickSize(height)
		    	.tickValues(xScale.domain().filter(function(d, i) { return !(i % 12); }))
		    	.tickFormat(d3.timeFormat("%Y")) 
			
  			//Binds the data to the bars      
  			var bar = svg.selectAll(".bar")
  			  	.data(data)
  			  	.enter()
  			  	.append("rect")
  			  	.attr("class", "bar")
  			  	.attr("x", function(d) { return xScale(d.date); })
  			  	.attr("width", xScale.bandwidth())
  			  	.attr("y", function(d) { return yScale(Math.max(0, d.jobs)); })
				.attr("height", function(d) { return Math.abs(yScale(d.jobs) - yScale(0)); })
				.classed("current", function(d) { return d.date == xMax});
			
  			//Appends the y axis
			var yAxisGroup = svg.append("g")
				.attr("class", "y axis")
				.call(yAxis)
    			.selectAll("g")
    			.classed("g-baseline", function(d) { return d == 0 });

			//Appends the x axis		
			var xAxisGroup = svg.append("g")
				.attr("class", "x axis")
				.call(xAxis);

  		
  			//RESPONSIVENESS
  			d3.select(window).on("resize", resized);
  			
  			function resized() {

			//new margin
    			var newMargin = {top: 20, right: 10, bottom: 40, left: 35};

    			var newWidther = d3.select(".gia-chart").node().clientWidth;

    			var newWidth = newWidther - newMargin.left - newMargin.right;

    			//Change the width of the svg
    			d3.select("svg")
      				.attr("width", newWidth + newMargin.left + newMargin.right);

    			//Change the xScale
    			xScale
					.rangeRound([0, newWidth])

    			//Update the bars
    			d3.selectAll("rect")
    			  .attr("x", function(d) { return xScale(d.date); })
    			  .attr("width", xScale.bandwidth())

    			//Updates xAxis
    			d3.selectAll(".x.axis")
         			.call(xAxis);   

    			//Updates ticks
    			xAxis
     			 .scale(xScale)
     			 .tickValues(xScale.domain().filter(function(d, i) { return !(i % 12); }))

    			//Updates yAxis  
    			d3.selectAll(".y.axis")
      				.call(yAxis); 

    			yAxis
      				.tickSize(-newWidth);
  				};
		}
